let ctx: AudioContext | null = null;
let muted = false;

const getCtx = (): AudioContext | null => {
  if (!ctx) {
    const AC = window.AudioContext || (window as any).webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

function tone(
  freq: number,
  delay: number,
  dur: number,
  opts: {
    type?: OscillatorType;
    vol?: number;
    to?: number;
  } = {},
) {
  const c = getCtx();
  if (!c) return;
  const { type = "square", vol = 0.06, to } = opts;
  const t = c.currentTime + delay;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t);
  if (to) osc.frequency.exponentialRampToValueAtTime(to, t + dur);
  gain.gain.setValueAtTime(vol, t);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(t);
  osc.stop(t + dur + 0.02);
}

export const setMuted = (m: boolean) => {
  muted = m;
};
export const isMuted = () => muted;

export function play(name: string) {
  if (muted) return;
  switch (name) {
    case "start":
      [261, 329, 392, 523].forEach((f, i) => tone(f, i * 0.07, 0.12));
      break;
    case "move":
      tone(220, 0, 0.04, { vol: 0.03 });
      break;
    case "rotate":
      tone(380, 0, 0.07, { type: "triangle", vol: 0.05, to: 640 });
      break;
    case "land":
      tone(120, 0, 0.09, { type: "triangle", vol: 0.09, to: 70 });
      break;
    case "hard":
      tone(260, 0, 0.16, { type: "sawtooth", vol: 0.06, to: 45 });
      break;
    case "clear1":
    case "clear2":
    case "clear3":
    case "clear4": {
      const n = Number(name.slice(5)) + 2;
      for (let i = 0; i < n; i++)
        tone(392 * Math.pow(1.122, i * 2), i * 0.06, 0.14, {
          type: "square",
          vol: 0.06,
        });
      break;
    }
    case "over":
      [392, 330, 262, 196, 131].forEach((f, i) =>
        tone(f, i * 0.16, 0.25, { type: "sawtooth", vol: 0.06 }),
      );
      break;
  }
}
